export default __webpack_public_path__ + "static/header-logo-0fec0225d189bc0eae27dac3e3770582.gif";